import React from 'react';


const Footer = () => {
	return (
		<footer className='footer'>
			<p>© 2024 Expansis Pro. Todos los derechos reservados.</p>
		</footer>
	);
};

export default Footer;
